"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect, useId } from "react";

const SentryFeedbackButton = () => {
  const buttonId = useId();

  useEffect(() => {
    const feedback = Sentry.getFeedback();
    const button = document.getElementById(buttonId);

    if (!feedback || !button) {
      return;
    }

    feedback.attachTo(button, {
      colorScheme: "system",
      showBranding: false,
      showName: false,
      showEmail: false,
      isNameRequired: false,
      isEmailRequired: false,
      formTitle: "Share feedback",
    });
  }, [buttonId]);

  return (
    <button
      className="fixed right-4 bottom-[max(5rem,calc(env(safe-area-inset-bottom)+1rem))] z-50 min-h-11 touch-manipulation rounded-md border border-border !bg-background px-3 py-2 font-medium text-sm !text-foreground shadow-sm transition-colors hover:!bg-accent hover:!text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 md:bottom-[max(1rem,env(safe-area-inset-bottom))] print:hidden"
      id={buttonId}
      type="button"
    >
      Feedback
    </button>
  );
};

export default SentryFeedbackButton;
